import { Reveal } from "./Reveal";
import { MessagesSquare, FileHeart, ShieldCheck } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

// Honest value propositions for referring clinicians (no fabricated quotes).
const PILLARS = [
  {
    icon: MessagesSquare,
    title: "Seamless Referrals",
    body: "Your patient is treated only for the agreed procedure and returned to you for continued care — your relationship is always respected.",
  },
  {
    icon: FileHeart,
    title: "Transparent Communication",
    body: "Detailed treatment notes, radiographs and clinical photographs shared at every stage, so you stay informed throughout.",
  },
  {
    icon: ShieldCheck,
    title: "Predictable Outcomes",
    body: "Evidence-based prosthodontic protocols and digital planning deliver consistent, literature-backed results you can rely on.",
  },
];

export const Testimonials = () => {
  return (
    <section id="referrals" data-testid="referrals-section" className="bg-ivory-darker py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <p className="text-champagne-dark text-xs uppercase tracking-[0.3em] mb-6">
              For Referring Dentists
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-emerald leading-[1.05]">
              A trusted partner for your practice.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-emerald/60 text-base md:text-lg leading-relaxed">
              Dr. Mishra works alongside general dentists and specialists across the Mumbai
              Metropolitan Region — handling complex prosthodontic, implant and maxillofacial cases
              while keeping your patient relationship at the centre.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {PILLARS.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                data-testid={`referral-pillar-${i}`}
                className="h-full bg-ivory border border-champagne/25 p-8 md:p-9 flex flex-col transition-transform duration-500 hover:-translate-y-2"
              >
                <div className="h-12 w-12 flex items-center justify-center bg-emerald text-champagne">
                  <p.icon size={22} />
                </div>
                <h3 className="mt-7 font-display font-light text-2xl text-emerald tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-emerald/60 text-sm md:text-base leading-relaxed flex-1">
                  {p.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between border-t border-emerald/10 pt-10">
            <p className="text-emerald/70 text-base md:text-lg max-w-xl">
              Have a case you&rsquo;d like to discuss or refer?
            </p>
            <button
              data-testid="referrals-contact-btn"
              onClick={() => scrollToId("contact")}
              className="bg-emerald text-ivory px-8 py-4 uppercase tracking-[0.15em] text-sm hover:bg-emerald-light transition-colors duration-300 whitespace-nowrap"
            >
              Start a Referral
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
